export const vmax = val => {
    const { innerWidth: w, innerHeight: h } = window;
    const max = (w > h) ? w : h;
    return ((max / 100) * val);
}

export const isMobile = ((window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth) <= 480)
